import React, { ReactNode } from "react";
import { paidTasksCaseStyle } from "./paidTasksCaseStyle";
import Grid from "@mui/material/Grid";
import CircleIcon from "../../CircleIcon/CircleIcon";
import { ReportProblemOutlined, WorkOutlineOutlined } from "@mui/icons-material";
import { PAID_TASK_STATUS_ASSIGNED, PAID_TASK_STATUS_IN_PRE_REVIEW, PAID_TASK_STATUS_CREATED, PAID_TASK_STATUS_IN_REVIEW } from "../paidTaskStatus";
import { PaidTask } from "../../../types/PaidTask";
import dayjs from "dayjs";

type PaidTaskCaseHeadProps = {
  paidTask: PaidTask;
  actions?: ReactNode;
};

const PaidTaskCaseHead = ({ paidTask, actions }: PaidTaskCaseHeadProps) => {
  const getPaidTaskStyles = () => {
    if (paidTask.status >= PAID_TASK_STATUS_IN_REVIEW || paidTask.deletedDate) {
      return paidTasksCaseStyle.done;
    }

    if (paidTask.status === PAID_TASK_STATUS_CREATED && dayjs().isAfter(paidTask.assignmentDeadline, "day")) {
      return paidTasksCaseStyle.overdue;
    }

    if ([PAID_TASK_STATUS_ASSIGNED, PAID_TASK_STATUS_IN_PRE_REVIEW].includes(paidTask.status) && dayjs().isAfter(paidTask.doneDeadline, "day")) {
      return paidTasksCaseStyle.overdue;
    }
  };

  return (
    <Grid container>
      <Grid sx={paidTasksCaseStyle.imageGridItem}>
        <CircleIcon icon={<WorkOutlineOutlined color={"secondary"} />} type={"muiIcon"} />
      </Grid>
      <Grid sx={paidTasksCaseStyle.activityContent}>
        <Grid container>
          <Grid sx={getPaidTaskStyles()} size={12}>
            <Grid
              container
              sx={[{
                alignItems: "center"
              }, paidTasksCaseStyle.activityContentContainer]}>
              <Grid sx={paidTasksCaseStyle.innerHeadline}>
                {paidTask.subject}
              </Grid>
              {paidTask.status !== PAID_TASK_STATUS_IN_REVIEW && (
                <Grid>
                  <ReportProblemOutlined />
                </Grid>
              )}
              <Grid sx={paidTasksCaseStyle.activityInfo}>
                {dayjs(paidTask.doneDeadline).format("DD.MM.YYYY")} |{" "}
                {paidTask.assignee ? paidTask.assignee.person.fullname : "Noch nicht zugeordnet"}
              </Grid>
              {actions && (
                <Grid sx={paidTasksCaseStyle.activityActions}>
                  {actions}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PaidTaskCaseHead;
